import axios from '@/helpers/axios'

export default {
  /**
   * 获取运营商列表数据
   *
   * @param {object} params 参数
   * @param {string} params.sp_type 运营商类型。 directly / evcs / third_party
   * @returns {Promise<Array>} 格式 []
   *
   */
  getServiceProviders(params) {
    return axios.get(`/backend/v2/options/service_providers`, { params })
  },
  /**
   * 获取指定桩的告警数据
   *
   * @param {object} params 参数
   * @returns {Promise<Array>} 格式 []
   *
   */
  getAlarms(params) {
    return axios.get(`/backend/v2/options/alarms`, { params })
  },
  /**
   * 获取运营商列表数据
   *
   * @returns {Promise<Array>} 格式 []
   *
   */
  getParkingReliefs() {
    return axios.get(`/backend/v2/options/parking_reliefs`)
  },
  /**
   * 获取告警等级列表数据
   *
   * @returns {Promise<Array>} 格式 []
   *
   */
  getAlarmCategories() {
    return axios.get(`/backend/v2/options/alarm_categories`)
  },

  /**
   * 获取告警规则策略列表数据
   *
   * @returns {Promise<Array>} 格式 []
   *
   */
  getAlarmNotificationRules() {
    return axios.get(`/backend/v2/options/alarm_notification_rules`)
  },

  /**
   * 获取未绑定枪口的地锁列表数据
   *
   * @returns {Promise<object>} 格式 { options: [{ id, name }] }
   */
  getUnboundParkingLocks() {
    return axios.get(`/backend/v2/options/unbound_parking_locks`)
  },
  /**
   * 获取地锁选项列表
   *
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   * @returns {Promise<object>} 格式 { options: [{ id, name }] }
   */
  getParkingLocks(params) {
    return axios.get('/backend/v2/options/parking_locks', { params })
  },
  /**
   * 获取商品列表
   *
   * @returns {Promise<Array>} 格式 []
   * @param {object} params 查询
   */
  getProducts(params) {
    return axios.get(`/backend/v2/options/products`, { params })
  },
  /**
   * 获取优惠券列表数据
   *
   * @returns {Promise<Array>} 格式 []
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   */
  getV1CouponDefinitions(params) {
    return axios.get(`/backend/options/coupon_definitions`, { params })
  },
  /**
   * 获取可用的优惠券列表数据
   *
   * @returns {Promise<Array>} 格式 []
   * @param {object} params 查询
   */
  getCouponDefinitions(params) {
    return axios.get(`/backend/v2/options/coupon_definitions`, { params })
  },
  /**
   * 获取优惠券详情
   *
   * @param {string} id 优惠券ID
   * @returns {Promise<object>} 格式 { options: [{ id, name, mobile, avatar, status }] }
   */
  getCouponDefinition(id) {
    return axios.get(`/backend/coupon_definitions/${id}`)
  },
  /**
   * 获取VIP会员权益
   *
   * @returns {Promise<Array>} 格式 []
   */
  getMemberShips() {
    return axios.get(`/backend/v2/options/memberships`)
  },
  /**
   * 获取会员商品列表
   *
   * @returns {Promise<Array>} 格式 []
   */
  getMemberProducts() {
    return axios.get(`/backend/v2/options/products`, { params: { saleable_type: 'Membership' } })
  },
  /**
   * 获取奖品列表数据
   *
   * @returns {Promise<Array>} 格式 []
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   */
  getPrizeDefinitions(params) {
    return axios.get(`/backend/v2/products`, { params })
  },
  /**
   * 获取用户选项列表
   *
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   * @returns {Promise<object>} 格式 { options: [{ id, name, mobile, avatar, status }] }
   */
  getUsers(params) {
    return axios.get('/backend/options/users', { params })
  },

  /**
   * 返回指定的用户选项信息
   *
   * @param {string} userId 用户ID
   * @returns {Promise<object>} 格式：{ id, name, mobile, avatar, status }
   */
  getUser(userId) {
    return axios.get(`/backend/options/users/${userId}`)
  },

  /**
   * 获取电站选项列表
   *
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   * @returns {Promise<object>} 格式 { options: [{ id, name, mobile, avatar, status }] }
   */
  getStations(params) {
    return axios.post('/backend/v2/options/charge_stations', params)
  },
  /**
   * 获取指定电站下的充电桩选项列表
   *
   * @param {string} charge_station_id 电站ID
   * @returns {Promise<object>} 格式 { options: [{ id, name, mobile, avatar, status }] }
   */
  getChargers(charge_station_id) {
    return axios.post('/v2/options/chargers?charge_station_id=' + charge_station_id)
  },

  /**
   * 返回指定的电站选项信息
   *
   * @param {object} params 查询参数
   * @param {string} params.stationID 电站ID
   * @returns {Promise<object>} 格式：{ id, name }
   */
  getStation(params) {
    return axios.post(`/backend/v2/options/charge_stations`, params)
  },

  /**
   * 获取可选的充电包信息
   *
   * @returns {Promise<Array>} 格式 [{ id, name, .... }]
   */
  getChargingPackageDefinitionOptions() {
    return axios.get('/backend/v2/options/charging_package_definitions')
  },

  /**
   * 获取可选的充电卡信息
   *
   * @param {object} params 查询参数
   * @param {string} params.keyword 关键词
   * @returns {Promise<Array>} 格式 [{ id, name, .... }]
   */
  getChargingCardDefinitionOptions(params) {
    return axios.get('/backend/v2/options/charging_card_definitions', { params })
  },
  /**
   * 获取指定的充电卡信息
   *
   * @param {string} cardId 管理员ID
   *
   * @returns {Promise<object>} 格式: { id, name, ... }
   */
  getChargingCardDefinition(cardId) {
    return axios.get(`/backend/v2/charging_card_definitions/${cardId}`)
  },

  /**
   * 返回可选的管理员信息
   *
   * @returns {Promise<Array>} 格式 [{ id, name, ... }]
   */
  getAdminOptions() {
    return axios.get('/backend/v2/options/admins')
  },
  /**
   * 返回指定的管理员的选项信息
   *
   * @param {string} adminId 管理员ID
   *
   * @returns {Promise<object>} 格式: { id, name, ... }
   */
  getAdmin(adminId) {
    return axios.get(`/backend/v2/options/admins/${adminId}`)
  },
  /**
   *
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   *
   * @returns {Promise<object>} 格式 [{ id, name, ... }]
   */
  getAdmins(params) {
    return axios.get('/backend/v2/options/admins', { params })
  },
  /**
   * 获取站列表选项
   *
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   * @returns {Promise<object>} 空body
   */
  getChargeStationOptions(params) {
    return axios.post('/backend/v2/options/charge_stations', params)
  },

  /**
   * 获取运营商列表选项
   *
   * @returns {Promise<object>} 空body
   */
  getServiceProviderOptions() {
    return axios.get('/backend/v2/options/service_providers')
  },

  /**
   * 获取集团列表选项
   *
   * @param {object} params 查询
   *
   * @returns {Promise<object>} 空body
   */
  getGroups(params) {
    return axios.get('/backend/options/groups', { params })
  },
  /**
   * 获取指定集团优惠信息
   *
   * @param {string} id 编号
   * @returns {Promise<object>} 格式 { id, created_at, updated_at, .... }
   */
  getGroup(id) {
    return axios.get(`/backend/v2/groups/${id}`)
  },
  /**
   * 获取充电包列表选项
   *
   * @param {object} params 查询
   *
   * @returns {Promise<object>} 空body
   */
  getChargingPackages(params) {
    return axios.get('/backend/v2/options/charging_package_definitions', { params })
  },
  /**
   * 获取指定集团优惠信息
   *
   * @param {string} id 编号
   * @returns {Promise<object>} 格式 { id, created_at, updated_at, .... }
   */
  getChargingPackage(id) {
    return axios.get(`/backend/v2/charging_package_definitions/${id}`)
  },
  /**
   * 获取共享电站选项列表
   *
   * @param {object} params 参数
   * @param {string} params.keyword 关键字查询
   * @returns {Promise<object>} 格式 { options: [{ id, name, ... }] }
   */
  getEvChargingStations(params) {
    return axios.post('/backend/v2/options/ev_charging_stations', params)
  },
  /**
   *
   * @param {object} params 查询
   * @param {string} params.category 标签类型
   *
   * @returns {Promise<object>} 格式 [{ id, name, ... }]
   */
  getTags(params) {
    return axios.get('/backend/v2/options/tags', { params })
  },

  /**
   * 获取设备列表
   *
   * @param {object} params 参数
   * @returns {Promise<object>} 格式 { entities: [{ id, name }] }
   */
  getEquipmentProductions(params) {
    return axios.get('/backend/v2/options/equipment_productions', { params })
  },

  /**
   * 获取指定共享电站下的桩列表
   *
   * @param {object} params 参数
   * @param {string} params.ev_charging_station_id 站ID
   * @returns {Promise<object>} 格式 { entities: [{ id, name }] }
   */
  getEvChargingPiles(params) {
    return axios.get('/backend/v2/options/ev_charging_piles', { params })
  },
  /**
   * 获取指定共享电桩下的枪列表
   *
   * @param {object} params 参数
   * @param {string} params.ev_charging_pile_id 桩ID
   * @returns {Promise<object>} 格式 { entities: [{ id, serial_number }] }
   */
  getEvChargingGuns(params) {
    return axios.get('/backend/v2/options/ev_charging_guns', { params })
  },

  /**
   * 获取指定运营商下的费率列表选项
   *
   * @param {object} params 参数
   * @param {string} params.serviceProviderId 运营商ID
   * @param {string} params.keyword 关键字
   * @returns {Promise<object>} 格式 { entities: [{ id, name }] }
   */
  getBillingRules(params) {
    return axios.get('/backend/v2/options/billing_rules', { params })
  },
  /**
   * 获取互联互通平台商列表
   *
   * @param {object} params 参数
   * @param {string} params.keyword 平台商名称/组织机构代码
   * @returns {Promise<object>} 格式 { entities: [{ id, operator_name }] }
   */
  getEvcsOperators(params) {
    return axios.get('/backend/v2/options/evcs_operators', { params })
  },
  /**
   * 获取指定互联互通平台商信息
   *
   * @param {object} id 平台商ID
   * @returns {Promise<object>} 格式 { id, operator_name... }
   */
  getEvcsOperator(id) {
    return axios.get(`/backend/v2/evcs_operators/${id}`)
  },
  /**
   * 获取用户列表数据
   *
   * @returns {Promise<Array>} 格式 []
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   */
  getV2Users(params) {
    return axios.get(`/backend/v2/options/users`, { params })
  },
  /**
   * 获取充电桩品牌
   *
   * @returns {Promise<Array>} 格式 []
   */
  getChargerBrands() {
    return axios.get(`/backend/v2/options/enumerations`, { params: { enumeration_type: 'ChargerBrand' } })
  },
  /**
   * 获取充电桩类型。交流、直流
   *
   * @returns {Promise<Array>} 格式 []
   */
  getChargerTypes() {
    return axios.get(`/backend/v2/options/enumerations`, { params: { enumeration_type: 'ChargerType' } })
  },
  /**
   * 获取电桩的城市分布
   *
   * @returns {Promise<Array>} 格式 []
   */
  getChargerCities() {
    return axios.get(`/backend/v2/options/charger_cities`)
  },
  /**
   * 获取城市
   *
   * @returns {Promise<Array>} 格式 []
   * @param {object} params 参数
   */
  getCities(params) {
    return axios.get(`/backend/v2/options/cities`, { params })
  },
  /**
   * 获取省份
   *
   * @param {object} params 参数
   *
   * @returns {Promise<Array>} 格式 []
   */
  getProvinces(params) {
    return axios.get(`/backend/v2/options/provinces`, { params })
  },
  /**
   * 获取指定城市的地区
   *
   * @param {string} cityId 城市ID
   * @returns {Promise<Array>} 格式 []
   */
  getDistricts(cityId) {
    return axios.get(`/backend/v2/options/${cityId}/districts`)
  },
  /**
   * 根据编号前缀获取相似的 充电站|充电桩 编号
   *
   * @param {object} params 参数
   * @returns {Promise<object>} 格式 { entities: [] }
   */
  getRelatedCodes(params) {
    return axios.get(`/backend/v2/options/related_codes`, { params })
  },
  /**
   * 获取App跳转页列表
   *
   * @returns {Promise<object>} 格式 { entities: [] }
   */
  getAppPages() {
    return axios.get(`/backend/v2/options/app_pages`)
  },
  /**
   * 获取角色信息
   *
   * @param {object} params 参数
   * @param {string} params.service_provider_id 运营商
   * @returns {Promise<object>} 格式 { entities: [] }
   */
  getRoles(params) {
    return axios.get(`/backend/v2/options/roles`, { params })
  },
  /**
   * 获取集团列表选项
   * 与 getGroups 区分
   *
   * @param {object} params 查询
   * @param {string} params.keyword 关键词字
   *
   * @returns {Promise<object>} 空body
   */
  getV2Groups(params) {
    return axios.get('/backend/v2/options/groups', { params })
  },

  /**
   * 获取商品提货点列表
   *
   *
   * @returns {Promise<object>} 空body
   */
  getPickupLocations() {
    return axios.get('/backend/v2/options/pickup_locations')
  },

  /**
   * 获取活动列表
   *
   * @param {object} params 查询
   *
   * @returns {Promise<object>} 空body
   */
  getTriggers(params) {
    return axios.get('/backend/v2/options/triggers', { params })
  },

  /**
   * 获取用户汽车列表
   *
   * @param {object} params 查询
   *
   * @returns {Promise<object>} 空body
   */
  getCars(params) {
    return axios.get('/backend/v2/options/cars', { params })
  },

  /**
   * 获取汽车品牌列表
   *
   *
   * @returns {Promise<object>} 空body
   */
  getCarBrands() {
    return axios.get('/backend/v2/options/car_brands')
  },

  /**
   * 获取汽车型号列表
   *
   * @param {object} params 查询
   * @returns {Promise<object>} 空body
   */
  getCarTypes(params) {
    return axios.get('/backend/v2/options/car_types', { params })
  },

  /**
   * 获取结算规则列表
   *
   * @param {object} params 查询
   * @returns {Promise<object>} 空body
   */
  getSettlementRules(params) {
    return axios.get('/backend/v2/options/settlement_rules', { params })
  },

  /**
   * 获取广告位列表
   *
   * @param {object} params 查询
   * @returns {Promise<object>} 空body
   */
  getAdvertisingSpaces(params) {
    return axios.get('/backend/v2/options/advertising_spaces', { params })
  },

  /**
   * 获取充电渠道列表
   *
   * @param {object} params 查询
   * @returns {Promise<object>} 空body
   */
  getChargeChannels(params) {
    return axios.get('/backend/v2/options/charge_channels', { params })
  },
  /**
   * 获取可选的专属运营人员列表
   *
   * @param {object} params 查询
   * @returns {Promise<object>} 空body
   */
  getOperationalStaffs(params) {
    return axios.get(`/backend/v2/options/operational_staffs`, { params })
  },
  /**
   * 获取可选的资料模版列表
   *
   * @returns {Promise<Array>} 格式 []
   * @param {object} params 查询
   * @param {string} params.keyword 关键字查询
   */
  getMaterialTemplates(params) {
    return axios.get(`/backend/v2/options/material_templates`, { params })
  },
  /**
   * 获取指定资料模版信息
   *
   * @param {object} id 资料模版ID
   * @returns {Promise<object>} 格式 { id, name... }
   */
  getMaterialTemplate(id) {
    return axios.get(`/backend/v2/material_templates/${id}`)
  },
  /**
   * 获取客服资讯未解决原因列表
   *
   * @returns {Promise<object>} 格式 { id, name... }
   */
  getPostUnresolvedReasons() {
    return axios.get('/backend/v2/options/post_unresolved_reasons')
  }
}
